/**
 * The page a "go back" redirect (`/actions/refresh`, `res.backDontScroll`)
 * should return to.
 *
 * In the browser, Rill's adapter fills `Referrer` with the URL of its last
 * *real* navigation, so it misses query params a view mirrors into the URL
 * with a plain `history.replaceState` / `pushState` (e.g. the client
 * configuration list's `configFilters`). Redirecting there merges new params
 * onto that stale URL and silently drops the mirrored ones. The address bar
 * is still the current page while these requests are handled, so read it
 * directly. On the server the request header is all there is.
 */
export const getReferrerUrl = (req) =>
  process.browser && globalThis.location
    ? globalThis.location.href
    : req.get("Referrer");
